export default __webpack_public_path__ + "images/pictograms/safari.svg?bf5d99cf06e0d6bfead6d7f8bab9a3eb582587dd03804b775e51779b1a9dd7ec";